module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-dio-hasbi-saniskoro-3280130-61023faa4f5c557e6d5cc0b2d11f8fe0.jpg";